import api, { ApiResponse } from '../core/api';

export async function getSubscriptionSummary() {
  const res = await api.get('/subscriptions/summary');
  return res.data.data;
}

export async function getPlans() {
  const res = await api.get('/subscriptions/plans');
  return res.data.data;
}

export async function createPlan(data: Record<string, unknown>) {
  const res = await api.post('/subscriptions/plans', data);
  return res.data.data;
}

export async function getMetrics() {
  const res = await api.get('/subscriptions/metrics');
  return res.data.data;
}

export async function createMetric(data: Record<string, unknown>) {
  const res = await api.post('/subscriptions/metrics', data);
  return res.data.data;
}

export async function getSubscriptions(params?: { status?: string; page?: number }) {
  const res = await api.get<ApiResponse<unknown[]>>('/subscriptions/subscriptions', { params });
  return res.data;
}

export async function subscribe(planId: string, userId?: string) {
  const res = await api.post('/subscriptions/subscriptions', { planId, userId });
  return res.data.data;
}

export async function getUsageSummary(subscriptionId: string) {
  const res = await api.get(`/subscriptions/subscriptions/${subscriptionId}/usage`);
  return res.data.data;
}

export async function generateInvoice(subscriptionId: string) {
  const res = await api.post(`/subscriptions/subscriptions/${subscriptionId}/invoice`);
  return res.data.data;
}

export async function getInvoices(params?: { status?: string; page?: number }) {
  const res = await api.get<ApiResponse<unknown[]>>('/subscriptions/invoices', { params });
  return res.data;
}

export async function payInvoice(invoiceId: string) {
  const res = await api.post(`/subscriptions/invoices/${invoiceId}/pay`);
  return res.data.data;
}

export async function runBillingCycle() {
  const res = await api.post('/subscriptions/billing/run');
  return res.data.data;
}

export async function recordUsage(data: Record<string, unknown>) {
  const res = await api.post('/subscriptions/usage', data);
  return res.data.data;
}
